import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation(); // Nutzt den aktuellen Standort (die aktuelle Route)

  useEffect(() => {
    window.scrollTo(0, 0); // Scrollt immer nach oben
  }, [location]); // Wird jedes Mal ausgeführt, wenn sich die URL ändert (Seitenwechsel)

  return null; // Diese Komponente rendert nichts
};

export default ScrollToTop;
